import React from 'react';
import {
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  DialogContentText,
} from '@nextiva/next-ui-components';
import { StyledDialog } from '../../CustomDialog/CustomDialog.styled';

interface RegistrationDialogProps {
  handleButton1: () => void;
  handleButton2: () => void;
  open: boolean;
  buttonName1: string;
  buttonName2: string;
  title: string;
  content: string | React.ReactElement;
}

const dataTestId = 'PlatformAdminUI-RegistrationDialog';
export function RegistrationDialog({
  handleButton1,
  handleButton2,
  open,
  buttonName1,
  buttonName2,
  title,
  content,
}: RegistrationDialogProps) {
  return (
    <StyledDialog onClose={handleButton1} open={open} data-testid={dataTestId}>
      <DialogTitle
        variant="h5"
        color="#0B1029"
        sx={{ padding: 0 }}
        data-testid={`${dataTestId}-Title`}
      >
        {title}
      </DialogTitle>
      <DialogContent data-testid={`${dataTestId}-Content`}>
        <DialogContentText>
          <Typography variant="body2" color="#222648">
            {content}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          data-testid={`${dataTestId}-Button1`}
          onClick={handleButton1}
          variant="contained"
          sx={{
            '&.MuiButton-sizeMedium': {
              padding: '12px 18px',
            },
          }}
        >
          {buttonName1}
        </Button>
        <Button
          color="primary"
          data-testid={`${dataTestId}-Button2`}
          onClick={handleButton2}
          variant="contained"
          sx={{
            '&.MuiButton-sizeMedium': {
              padding: '12px 16px',
              marginLeft: '16px',
            },
          }}
        >
          {buttonName2}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}

export function NewRegistrationDialog({
  handleButton1,
  handleButton2,
  open,
}: {
  handleButton1: () => void;
  handleButton2: () => void;
  open: boolean;
}) {
  return (
    <RegistrationDialog
      handleButton1={handleButton1}
      handleButton2={handleButton2}
      open={open}
      buttonName1="Cancel"
      buttonName2="Create new registration"
      title="New registration needed"
      content="Editing use case(s) is not permitted for re-submission. To update the use case, a new registration must be submitted, which will incur minimum of 3 months of recurring fees."
    />
  );
}

export function CancelRegistrationDialog({
  handleButton1,
  handleButton2,
  open,
}: {
  handleButton1: () => void;
  handleButton2: () => void;
  open: boolean;
}) {
  return (
    <RegistrationDialog
      handleButton1={handleButton1}
      handleButton2={handleButton2}
      open={open}
      buttonName1="Cancel"
      buttonName2="Cancel new registration"
      title="Cancel new registration"
      content="Are you sure you want to cancel this registration and continue with the previous use case(s) selection?"
    />
  );
}
